/* tslint:disable */

export const VERSION = "27a59dc";

/* tslint:enable */
